import { render, staticRenderFns } from "./activityStatuses.vue?vue&type=template&id=62338926"
import script from "./activityStatuses.vue?vue&type=script&lang=js"
export * from "./activityStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports